export default "https://kr-a.kakaopagecdn.com/web/qa/5.3.1/static/v4/search/icon-search-a481ce2d3e597e4e970a585e07b6610d.svg";